import { render, staticRenderFns } from "./D1FolderDetail.vue?vue&type=template&id=dd6836ae"
import script from "./D1FolderDetail.vue?vue&type=script&lang=js"
export * from "./D1FolderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports